var bh = {
	containers: {
		widthEl: $('.window-width-helper'),
		heightEl: $('.window-height-helper'),
	},


	setHelpers: function(widthValue, heightValue) {
		bh.containers.widthEl.text(widthValue);
		bh.containers.heightEl.text(heightValue);
	},

	emptyLinks: function() {
		$('[href="#"]').click(function(e) {
			e.preventDefault();
		});
	}

};